// extracted by mini-css-extract-plugin
var _1 = "JUWSI__sliderWrapper1";
var _2 = "JUWSI__sliderWrapper2";
var _3 = "JUWSI__wrapper";
export { _1 as "sliderWrapper1", _2 as "sliderWrapper2", _3 as "wrapper" }
